import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";

import CSSModules from "lib/utils/css-modules";
import { MainView } from "lib/components/index";
import styles from "./MainLayout.less";
import TopBar from "./TopBar";
import LeftBar from "./LeftBar";
import { setLocation } from "modules/app/actions";
import { fetchCurrentCompany } from "modules/auth";

import NewOrderModal from "modules/orders/NewOrderModal/NewOrderModal";
import ShowSlotModal from "modules/calendar/ShowSlotModal/ShowSlotModal";
import { open as openShowSlotModal, close as closeShowSlotModal } from "modules/calendar/ShowSlotModal";
import EditCompanyMemberModal from "modules/settings/EditCompanyMemberModal/EditCompanyMemberModal";
import {
  open as openEditCompanyMemberModal,
  close as closeEditCompanyMemberModal,
} from "modules/settings/EditCompanyMemberModal";
import EditCustomerModal from "modules/customers/EditCustomerModal/EditCustomerModal";
import { open as openEditCustomerModal, close as closeEditCustomerModal } from "modules/customers/EditCustomerModal";
import EditReviewModal from "modules/reviews/EditReviewModal/EditReviewModal";
import { open as openEditReviewModal, close as closeEditReviewModal } from "modules/reviews/EditReviewModal";
import EditPaymentProfileModal from "modules/settings/EditPaymentProfileModal/EditPaymentProfileModal";
import {
  open as openEditPaymentProfileModal,
  close as closeEditPaymentProfileModal,
} from "modules/settings/EditPaymentProfileModal";
// TODO refactor those modals into some higher abstraction,
// component that stores all modals,
// shows only one currecntly opened recent one,
// updates the routes etc

@connect(
  (state) => ({
    currentCompanyId: state.auth.company.model ? state.auth.company.model.id : null,
    fetchCurrentCompanyLoading: state.auth.company.fetchLoading,
    fetchCurrentCompanyFailed: state.auth.company.fetchFailed,
    leftBarExtended: state.app.leftBarExtended,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        fetchCurrentCompany,
        setLocation,
        openShowSlotModal,
        closeShowSlotModal,
        openEditCompanyMemberModal,
        closeEditCompanyMemberModal,
        openEditCustomerModal,
        closeEditCustomerModal,
        openEditReviewModal,
        closeEditReviewModal,
        openEditPaymentProfileModal,
        closeEditPaymentProfileModal,
      },
      dispatch
    )
)
@CSSModules(styles)
export default class MainLayout extends React.PureComponent {
  componentDidMount() {
    this._respondToProps();
  }

  componentDidUpdate(prevProps) {
    this._respondToProps(prevProps);
  }

  _respondToProps(prevProps) {
    const {
      setLocation,
      openShowSlotModal,
      closeShowSlotModal,
      openEditCompanyMemberModal,
      closeEditCompanyMemberModal,
      openEditCustomerModal,
      closeEditCustomerModal,
      openEditReviewModal,
      closeEditReviewModal,
      openEditPaymentProfileModal,
      closeEditPaymentProfileModal,
    } = this.props;

    const prevLocation = prevProps && prevProps.location;
    const location = this.props.location;

    if (prevLocation !== location) {
      setLocation(location);
    }

    const prevQuery = (prevLocation && prevLocation.query) || {};
    const query = location.query || {};

    if (prevQuery.showSlot != query.showSlot) {
      if (query.showSlot) {
        openShowSlotModal({ id: +query.showSlot, action: query.action });
      } else {
        closeShowSlotModal();
      }
    }

    if (prevQuery.editMember != query.editMember) {
      if (query.editMember) {
        openEditCompanyMemberModal({ id: +query.editMember });
      } else {
        closeEditCompanyMemberModal();
      }
    }

    if (prevQuery.editCustomer != query.editCustomer) {
      if (query.editCustomer) {
        openEditCustomerModal({ id: +query.editCustomer });
      } else {
        closeEditCustomerModal();
      }
    }

    if (prevQuery.editReview != query.editReview) {
      if (query.editReview) {
        openEditReviewModal({ id: +query.editReview });
      } else {
        closeEditReviewModal();
      }
    }

    if (prevQuery.editProfile != query.editProfile) {
      if (query.editProfile) {
        openEditPaymentProfileModal({ id: +query.editProfile });
      } else {
        closeEditPaymentProfileModal();
      }
    }
  }

  renderContent() {
    if (this.props.currentCompanyId) {
      return (
        <div key={this.props.currentCompanyId} styleName="content-inner">
          {this.props.children}
          <NewOrderModal />
          <ShowSlotModal />
          <EditCompanyMemberModal />
          <EditCustomerModal />
          <EditReviewModal />
          <EditPaymentProfileModal />
          {/* <IntegrateOnlinePaymentsModal /> */}
        </div>
      );
    } else if (this.props.fetchCurrentCompanyLoading) {
      return (
        <div styleName="content-inner">
          <MainView.Dimmer loading />
        </div>
      );
    } else if (this.props.fetchCurrentCompanyFailed) {
      return (
        <div styleName="content-inner">
          <MainView.Dimmer failed retry={this.props.fetchCurrentCompany} />
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    return (
      <div
        styleName="container"
        className={classNames({
          "has-left-bar-extended": this.props.leftBarExtended,
        })}
      >
        <LeftBar params={this.props.params} />
        <TopBar params={this.props.params} />
        <div styleName="content">{this.renderContent()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/MainLayout.jsx